import { rem } from 'polished';
import styled from 'styled-components';

export const StyledHead = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-grow: 1;
    justify-content: center;
  }
`;

export const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin: 0;
  padding: 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: row;
  }
`;

export const StyledListItem = styled.li`
  margin-top: ${rem('8px')};
  margin-bottom: ${rem('8px')};
  list-style: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-top: ${rem('12px')};
    margin-right: ${rem('32px')};
    margin-bottom: ${rem('12px')};
    margin-left: ${rem('32px')};
  }
`;

export const StyledLink = styled.a`
  display: block;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-weight: 700;
  font-size: ${rem('24px')};
  letter-spacing: ${rem('-0.5px')};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.cross.black};
  }
`;
